import { numberWithCommas } from 'utility';

const columns = (currencyText) => [
  {
    title: 'شماره',
    field: 'id', // 1384
    align: 'center',
    filtering: false,
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'زمان مصرف',
    field: 'usageTime', // 1384
    align: 'center',
    filtering: false,
  },
  {
    title: 'شماره فاکتور',
    field: 'factorNumber', // 1384
    align: 'center',
    filtering: false,
  },
  {
    title: 'کسب‌وکار',
    field: 'biz', // 1384
    align: 'center',
    filtering: false,
  },
  {
    title: 'توضیحات',
    field: 'desc', // 1384
    align: 'center',
    filtering: false,
  },
  {
    title: `میزان مصرف - ${currencyText}`,
    field: 'usageAmount', // 1384
    align: 'center',
    filtering: false,
    render: (rc) => numberWithCommas(rc?.usageAmount),
  },
  {
    title: 'وضعیت',
    field: 'status', // 1384
    align: 'center',
    filtering: false,
  },
];

const columnsId = {
  invoiceId: '1349',
  tax: '1444',
  invoiceStatus: '1352',
  guildName: '1353',
  decreased: '1354',
  hasMultiInvoice: '1384',
};

const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      id: row.cols[0],
      usageTime: row.cols[2],
      factorNumber: row.cols[5],
      biz: row.cols[10],
      desc: row.cols[16],
      usageAmount: row.cols[3],
      status: row.cols[8],
    };
  });

  return newData;
};

export { columns, columnsId, generateData };
